import React, { useState, useEffect } from "react";
import "../styles/Pricing.css";
import { useLanguage } from "../contexts/LanguageContext";
import { detectCurrency, setCurrency } from "../utils/currency";
import { track } from "../utils/analytics";

const Pricing = () => {
  const { language, text } = useLanguage();
  const isHeb = language === "he";
  const p = text.pricing;
  const [currency, setCurrencyState] = useState("usd");

  useEffect(() => {
    setCurrencyState(detectCurrency());
  }, []);

  const switchCurrency = (cur) => {
    setCurrencyState(cur);
    setCurrency(cur);
    track("currency_toggle", { currency: cur });
  };

  return (
    <section id="pricing" className="pricing-section" dir={isHeb ? "rtl" : "ltr"}>
      <span className="eyebrow">{p.eyebrow}</span>
      <h2 className="section-title">{p.title}</h2>
      <p className="pricing-lede">{p.lede}</p>

      <div className="currency-toggle" role="group" aria-label="Currency">
        <button
          type="button"
          className={currency === "usd" ? "is-active" : ""}
          onClick={() => switchCurrency("usd")}
        >
          {p.currencyToggle.usd}
        </button>
        <button
          type="button"
          className={currency === "ils" ? "is-active" : ""}
          onClick={() => switchCurrency("ils")}
        >
          {p.currencyToggle.ils}
        </button>
      </div>

      <div className="pricing-grid">
        {p.plans.map((plan) => (
          <article
            key={plan.key}
            className={`plan-card ${plan.highlight ? "plan-card--highlight" : ""}`}
          >
            {plan.badge && <span className="plan-badge">{plan.badge}</span>}

            <header className="plan-head">
              <h3 className="plan-name">{plan.name}</h3>
              <p className="plan-tagline">{plan.tagline}</p>
              <div className="plan-price gradient-text">
                {currency === "ils" ? plan.priceLabelILS : plan.priceLabelUSD}
              </div>
            </header>

            <ul className="plan-features">
              {plan.features.map((f) => (
                <li key={f}>
                  <svg
                    viewBox="0 0 24 24"
                    fill="none"
                    stroke="currentColor"
                    strokeWidth="2.5"
                    aria-hidden="true"
                  >
                    <path d="M5 12l5 5L20 7" strokeLinecap="round" strokeLinejoin="round" />
                  </svg>
                  <span>{f}</span>
                </li>
              ))}
            </ul>

            <a
              className={`btn ${plan.highlight ? "btn-primary" : "btn-ghost"} plan-cta`}
              href="#contact"
              onClick={() =>
                track("plan_cta_click", { plan: plan.key, currency })
              }
            >
              {plan.ctaLabel}
              <svg viewBox="0 0 24 24" width="16" height="16" fill="none" stroke="currentColor" strokeWidth="2">
                <path d="M5 12h14M13 5l7 7-7 7" strokeLinecap="round" strokeLinejoin="round" />
              </svg>
            </a>
          </article>
        ))}
      </div>

      <p className="pricing-note">{p.note}</p>
    </section>
  );
};

export default Pricing;
